<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.997 16a2 2 0 1 1 1.891-2.662h1.1c.166 0 .324-.006.48-.022a2.559 2.559 0 0 0 2.155-1.786 2.944 2.944 0 0 1-1.2.273h-1.421V5.85h2.552a5.658 5.658 0 0 0-1.525-2.637A5.594 5.594 0 0 0 8.01 1.6h-.017a5.672 5.672 0 0 0-5.549 4.25H5v5.95H3.584A2.961 2.961 0 0 1 .668 8.816V7.185A7.265 7.265 0 0 1 7.997 0a7.268 7.268 0 0 1 7.337 7.18v3.548a4.146 4.146 0 0 1-3.7 4.176.02.02 0 0 1-.015 0 8.165 8.165 0 0 1-.637.028H9.768A2.012 2.012 0 0 1 8.004 16z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-support',
});
</script>
